module.exports = __webpack_public_path__ + "static/media/Sophia_S@3x.49dd2838.jpg";